<!--
  DATE,
  *TEXT,
  *CURRENCY,
  *TAXONOMY,
  COLLECTION_OF_TAXONOMY,
  NEWIN,
  SPECIAL_EDITION,
  CLASSIFICATIONS,
  BOOLEAN,
  STOCK,
  STORE_STOCK,
  NONE
-->

<!-- TODO: Censire filtro AccessoriesShape -->

<form [formGroup]="filtersService.form" (ngSubmit)="filtersService.submit()" class="needs-validation">

  @for(filter of filtersService.fields(); track filter.field){

  @switch (filter.type) {

  @case (TypeFilter.TEXT) {
  <app-multi-select [config]="filter.config" ngDefaultControl>
  </app-multi-select>
  }

  @case (TypeFilter.CURRENCY) {
  <!-- <app-input [formControl]="filtersService.getFormControl(filter.field)" [config]="filter.config" ngDefaultControl>
  </app-input> -->

  <app-price-range-input [config]="filter.config" [priceRange]="filter.priceRange" ngDefaultControl></app-price-range-input>
  }

  @case (TypeFilter.TAXONOMY) {
  <app-multi-select [config]="filter.config" ngDefaultControl>
  </app-multi-select>
  }

  }

  }

  <button class="btn btn-primary" type="submit" hidden>
  </button>

</form>
